import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader, Avatar  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';
import ban from '../../img/math.png'

export default class Modaldateopen extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท

                name_expert : '', //ผู้นำเสนอ
                username_expert : '', //ผู้นำเสนอ
                password_expert : '', //ผู้นำเสนอ
                affiliation_expert : '', //ผู้นำเสนอ
                expertise_expert : '', //ผู้นำเสนอ
                tel_expert : '', //ผู้นำเสนอ
                adminaddby : '', //ผู้นำเสนอ
                iduser:'',

                id_expert:'',


                id_dateopen:'',
                }
      
                this.toggle = this.toggle.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);
     
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.handleChangesend_username = this.handleChangesend_username.bind(this);
                // this.handleChangesend_password = this.handleChangesend_password.bind(this);
                // this.handleChangesend_affiliation = this.handleChangesend_affiliation.bind(this);
                // this.handleChangesend_expertise = this.handleChangesend_expertise.bind(this);
                // this.handleChangesend_tel = this.handleChangesend_tel.bind(this);
            
             
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 
}




 componentDidMount() {
   //    const { iduser } = this.props.iduser
    //   console.log(id_send);
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

    this.setState({ id_dateopen:this.props.id_dateopen})
    this.setState({ name_expert:dates})

    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 
    //   }, 0);

  }




handleChangesend_name(event) {  
    const dArr = event.target.value.split("-");  // ex input: "2010-01-18"
    const ddd = dArr[2]+ "-" +dArr[1]+ "-" +dArr[0];

      //this.setState({name_expert: event.target.value}); 
      this.setState({name_expert: ddd}); 
     }

handleChangesend_username(event) {    this.setState({username_expert: event.target.value});  }
// handleChangesend_password(event) {    this.setState({password_expert: event.target.value});  }
// handleChangesend_affiliation(event) {    this.setState({affiliation_expert: event.target.value});  }
// handleChangesend_expertise(event) {    this.setState({expertise_expert: event.target.value});  }
// handleChangesend_tel(event) {    this.setState({tel_expert: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    //  datafrm.append("send_id", this.props.iduser);
      datafrm.append("close_dateopen", this.state.name_expert);
      datafrm.append("id_dateopen", this.props.id_dateopen);
     

    api.post("registercon/updatesdateopen",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
 

    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
     //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
            Swal.fire({
            title: 'แก้ไขข้อมูลวันปิดเรียบร้อย',
            text: "Add a successful person",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง'
            }).then((result) => {
            if (result.isConfirmed) {
                // Swal.fire(
                //   'Deleted!',
                //   'Your file has been deleted.',
                //   'success'
                // )
                this.props.list();
                this.toggle()
            }
            })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })
}, 2000);

    //window.location.href = '/adminfaculty'
    //this.props.updateat();
    //this.getExpert()

  }

  

    render() {
        
           console.log(this.state.name_expert)
        //   console.log(this.state.major_precent)
        //   console.log(this.state.name_present)
        //   console.log(this.state.send_name)
        //   console.log(this.state.send_uploadeword1)
        //   console.log(this.state.send_uploadepdf1)
        //   console.log(this.state.radio)

        const date = new Date();
         // const date = this.state.name_expert;
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const datess = day+"-"+month+"-"+year ;
        //  console.log(date)


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="amber" size='sm' onClick={this.toggle}><MDBIcon icon="plus-square" />  แก้ไขข้อมูลวันเปิด-ปิด</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}><Avatar src="https://cdn-icons-png.flaticon.com/512/4514/4514882.png" /> แก้ไขข้อมูลวันเปิด-ปิด</MDBModalHeader>
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div className='text-black'>
              <br/>
                
                    <h3>รายการ : {this.props.name_dateopen}</h3>

                    {/* <div className="mb-2">
                           <label className="black-text"><strong>วันที่เปิด</strong></label>
                           <input type='text' className="form-control"  name="name" 
                                 placeholder="กรุณาระบุชื่อผู้ทรงคุณวุฒิ" value={this.props.start_dateopen} disabled />
                            </div> */}

                            <div className="mb-2">
                           <label className="black-text"><strong>วันที่ปิด</strong></label>
                           <input type='date' className="form-control" onChange={this.handleChangesend_name} name="name" 
                                 placeholder="กรุณาระบุวันที่ปิด"  required />
                            </div>
                  

                          


              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
